export default {
  'initial.dataset.multiLevelPie': function () {
    let datasetConf = this.config,
      ringpath;

    return {
      'ringpath.appearing': function (inputJSON) {
        ringpath = inputJSON.attr.ringpath;
        return [
          {
            initialAttr: {
              ringpath: [ringpath[0], ringpath[1], ringpath[2], ringpath[3],
                datasetConf.initialAngle, datasetConf.initialAngle]
            },
            slot: 'plot'
          }
        ];
      },
      'text.appearing': () => {
        return [
          {
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: 'final'
          }
        ];
      }
    };
  }
};
